import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import axios from '@/app/axios'
import debounce from 'lodash/debounce'
import { Debouceable } from '@/app/types/debouncable'
import NodeEntity from '@/common/models/node-entitiy'
import Responses from '@/app/utils/responses'

@Component
export default class GroupInput extends Vue {

  @Prop({ required: true })
  private projectId!: string

  @Prop({ required: true })
  private containerId!: string

  @Prop({ required: true })
  private value!: string[]

  @Prop({ required: true })
  private entityLabel!: string

  @Prop({ required: true })
  private entitiesLabel!: string

  @Prop({ required: true })
  private url!: string

  @Prop({ default: 3 })
  private counter!: boolean | number | string

  @Prop({ required: true })
  private tooltipMessage!: string

  @Prop({ default: 0 })
  private minElements!: number

  @Prop({ default: false })
  private archived!: boolean

  private items: any[] = []
  private model: any[] = []
  private search = ''
  private loading: boolean = false

  private debouncedLoad: Debouceable = null

  private get errors() {
    if (this.model.length === 0) {
      return ['Mindestens eine Gruppe muss ausgewählt werden.']
    }
    return []
  }

  @Watch('value', { deep: true })
  private valueChanged(val: string[], old: string[]) {
    if (val !== old) {
      this.model = this.items.filter((i) => val.includes(i.id))
    }
  }

  @Watch('search')
  private async searchUpdated(val: string, old: string) {
    if (val !== old) {
      await this.findMatchesDebounced()
    }
  }

  private async loadSelection() {
    const res = await axios.get<NodeEntity[]>(`${this.url}/${this.containerId}`)
    this.model = Responses.list(res)
  }

  private async findMatchesDebounced() {
    if (this.debouncedLoad) {
      this.debouncedLoad.cancel()
    }
    this.debouncedLoad = debounce(async () => this.findMatches(this.search), 500)
    this.debouncedLoad()
  }

  private async findMatches(text: string = '') {
    this.loading = true
    const matches = await this.fetchMatches(text)
    this.items = []
    this.items.push({ header: 'Vervollständigung' })
    this.items.push(...matches)
    this.loading = false
  }

  private async fetchMatches(text: string = '') {
    const res = await axios.post<NodeEntity[]>(this.url, {
      projectId: this.projectId,
      text,
    })
    return Responses.list(res)
  }

  private async onInput(val: any[]) {
    if (val.length >= this.minElements) {
      this.$emit('input', val.map((v) => v.id))
    }
  }

  private highlight(v: string) {
    const regex = new RegExp(`(${this.search})`, 'ig')
    return v.replace(regex, '<strong>$1</strong>')
  }

  private async mounted() {
    // await this.findMatches()
    await this.loadSelection()
  }
}
